'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils');

var _State = require('./providers/State');

var _State2 = _interopRequireDefault(_State);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseModel = function () {
  function BaseModel(controller) {
    _classCallCheck(this, BaseModel);

    this.initialState = (0, _utils.extractModuleProp)(controller.module, 'state');
    this.StateProvider = _State2.default;
    this.changedPaths = [];

    controller.on('moduleAdded', this.onModuleAdded.bind(this));
    controller.on('moduleRemoved', this.onModuleRemoved.bind(this));
  }

  _createClass(BaseModel, [{
    key: 'onModuleAdded',
    value: function onModuleAdded(path, module) {
      this.set(path, module.state);
    }
  }, {
    key: 'onModuleRemoved',
    value: function onModuleRemoved(path) {
      this.unset(path);
    }
  }, {
    key: 'flush',
    value: function flush() {
      var changes = this.changedPaths.slice();

      this.changedPaths = [];

      return changes;
    }
  }]);

  return BaseModel;
}();

exports.default = BaseModel;
//# sourceMappingURL=BaseModel.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/BaseModel.js
// module id = 251
// module chunks = 0